/**
 * Samouczek 'Kupony - jak sprawdzic kupon'. Ksztalt danych: patrz KONTRAKT.md
 */
const OBRAZ = (plik, opis) => ({ plik, opis });

// Dwa dzialy, bo sa dwa rozne miejsca: szybkie okno przy kasie (klient stoi
// i czeka) oraz pelna lista z historia (gdy trzeba dojsc, co sie z karta dzialo).
const DZIALY = {
  A: { tytul: 'Szybko przy kasie — okno „Sprawdz kupon"', opis: 'Klient pyta, ile ma na karcie. Odpowiedź w trzy kliknięcia, bez wchodzenia w płatność i bez ruszania koszyka.' },
  B: { tytul: 'Pełny obraz — zakładka „Kupony" i historia', opis: 'Gdy trzeba zobaczyć więcej: na jakich paragonach karta była użyta, kiedy, przez kogo.' },
};

const KUPON_SPRAWDZ = {
  id: 'kupon-sprawdz',
  dzialy: DZIALY,
  tytul: 'Kupony — jak sprawdzić kupon (saldo, ważność, historia)',
  dlaKogo: 'Kasjerzy',
  czas: '3 minuty',
  pdf: '/instrukcje/kupon-sprawdz.pdf',
  wstep: 'Klient przychodzi z kartą podarunkową i pyta, ile na niej zostało albo czy jest jeszcze ważna. '
    + 'Sprawdzisz to w dwóch miejscach: najszybciej w kasie, w oknie „Sprawdz kupon", a dokładniej — z całą historią '
    + 'użyć — w zakładce „Kupony". Samo sprawdzenie niczego nie zmienia: nie zdejmuje pieniędzy z karty i nie zamyka sprzedaży.',
  kroki: [
    {
      n: 1,
      dzial: 'A',
      tytul: 'Kliknij „Sprawdz kupon" w kasie',
      tresc: 'W kasie, w pasku nad koszykiem (obok wyszukiwarki klienta) jest fioletowy przycisk „Sprawdz kupon". '
        + 'Kliknij go. Nie ma znaczenia, czy koszyk jest pusty, czy w trakcie sprzedaży — sprawdzenie karty '
        + 'niczego w koszyku nie zmienia.',
      obraz: OBRAZ('/instrukcje/kupon-sprawdz-1-pos-przycisk.jpg', 'Przycisk Sprawdz kupon w pasku nad koszykiem w kasie'),
    },
    {
      n: 2,
      dzial: 'A',
      tytul: 'Wpisz kod i kliknij „Sprawdz"',
      tresc: 'Otwiera się małe okno „Sprawdz kupon" z jednym polem „Kod kuponu:". Zeskanuj kod kreskowy z karty '
        + 'albo wpisz go ręcznie — system rozpoznaje zarówno kod nadrukowany na karcie, jak i kod systemowy z paragonu. '
        + 'Wielkość liter nie ma znaczenia. Kliknij „Sprawdz" albo wciśnij Enter. Przycisk jest szary, dopóki kod ma mniej niż 4 znaki.',
      obraz: OBRAZ('/instrukcje/kupon-sprawdz-2-okno-kod.jpg', 'Okno Sprawdz kupon z wpisanym kodem i przyciskiem Sprawdz'),
    },
    {
      n: 3,
      dzial: 'A',
      tytul: 'Odczytaj wynik: status, saldo, ważność',
      tresc: 'Zielona ramka to dobra wiadomość. „Status: Aktywny" — kartą można płacić. „Saldo:" to kwota, która '
        + 'ZOSTAŁA na karcie (nie wartość, za jaką była kupiona — jeśli klient już częściowo ją wykorzystał, zobaczysz resztę). '
        + '„Wazny do:" to ostatni dzień, w którym karta działa. Tę kwotę i datę podajesz klientowi. Potem „Zamknij".',
      obraz: OBRAZ('/instrukcje/kupon-sprawdz-3-wynik-aktywny.jpg', 'Wynik sprawdzenia: status Aktywny, saldo 50,01 zł, ważny do 14.11.2026'),
    },
    {
      n: 4,
      dzial: 'A',
      tytul: 'Żółta ramka — kupon nieaktywny',
      tresc: 'Jeśli ramka jest żółta i pisze „Status: Nieaktywny", pod spodem znajdziesz powód. Dwa najczęstsze: '
        + '„Kupon został już wykorzystany" (saldo 0,00 zł) albo „Kupon wygasł" z datą. Uwaga: przy karcie po terminie '
        + 'system nadal pokazuje saldo (na zrzucie 70,00 zł) — ale nie pozwoli nim zapłacić. '
        + 'Jeśli zamiast ramki pojawia się czerwony komunikat „Kupon … nie został znaleziony", kod jest błędnie wpisany '
        + 'albo karta nie została wystawiona w naszym systemie — sprawdź kod jeszcze raz, litera po literze.',
      obraz: OBRAZ('/instrukcje/kupon-sprawdz-4-wynik-nieaktywny.jpg', 'Wynik sprawdzenia: status Nieaktywny, komunikat Kupon wygasł 2026-01-01'),
    },
    {
      n: 5,
      dzial: 'B',
      tytul: 'Otwórz zakładkę „Kupony" i wpisz kod',
      tresc: 'W menu po lewej kliknij „Kupony" (ikona biletu). U góry są trzy filtry: „Wszystkie", „Aktywne", „Wykorzystane" '
        + '— liczby w nawiasach mówią, ile kuponów jest w każdej grupie. W polu „Szukaj po kodzie kuponu lub numerze telefonu..." '
        + 'wpisz kod z karty; lista zawęża się w trakcie pisania. Jeśli klient nie ma karty przy sobie, a przy zakupie podał '
        + 'telefon, możesz szukać po numerze telefonu.',
      obraz: OBRAZ('/instrukcje/kupon-sprawdz-5-lista-szukaj.jpg', 'Zakładka Kupony z wyszukiwarką, filtrami i znalezionym kuponem'),
    },
    {
      n: 6,
      dzial: 'B',
      tytul: 'Odczytaj wiersz: Wartość, Status, Ważność, Paragon',
      tresc: '„Wartość" to saldo — ile ZOSTAŁO na karcie. „Status" ma dwa stany: „✅ Aktywny" (można płacić) i '
        + '„🔴 Wykorzystany" (saldo zeszło do zera). „Ważność" to data, po której karta przestaje działać — '
        + 'lista NIE oznacza kart po terminie osobno, karta wygasła nadal ma tu status „Aktywny", więc zawsze porównaj datę '
        + 'z dzisiejszą. W kolumnie „Paragon" widzisz numer paragonu, na którym kupon był użyty; '
        + 'dopisek „+1" oznacza, że użyć było więcej — kliknięcie w niego otwiera historię.',
      obraz: OBRAZ('/instrukcje/kupon-sprawdz-6-wiersz-kolumny.jpg', 'Wiersz kuponu z zaznaczonymi kolumnami Wartość, Ważność i Paragon'),
    },
    {
      n: 7,
      dzial: 'B',
      tytul: 'Kliknij „Akcje", potem „Historia"',
      tresc: 'Na końcu wiersza jest przycisk „⚙️ Akcje". Po kliknięciu rozwija się menu — wybierz „📜 Historia". '
        + 'Przy kuponie aktywnym w tym samym menu jest też „💳 Użyj" — to już jest realizacja kuponu, nie sprawdzenie, '
        + 'więc jeśli chcesz tylko sprawdzić, nie klikaj w to.',
      obraz: OBRAZ('/instrukcje/kupon-sprawdz-7-akcje-historia.jpg', 'Rozwinięte menu Akcje z pozycją Historia przy kuponie wykorzystanym'),
    },
    {
      n: 8,
      dzial: 'B',
      tytul: 'Przeczytaj „Historię kuponu"',
      tresc: 'Okno ma dwie części. „Informacje o kuponie": kod, status, data ważności i numer paragonu. '
        + '„Historia wydarzen": pierwszy wpis to „Kupon utworzony" (data, sklep, forma płatności przy zakupie), '
        + 'a każde kolejne „Wykorzystano … zł" to jedno użycie karty. W szczegółach użycia opisy są techniczne: '
        + '„receipt_number" to numer paragonu, „cashier" — kasjer, „amount_used" — zdjęta kwota. '
        + 'Gdy klient twierdzi, że „nic nie kupował", to tutaj masz datę, kwotę i paragon. Zamykasz przyciskiem „Zamknij".',
      obraz: OBRAZ('/instrukcje/kupon-sprawdz-8-historia.jpg', 'Okno Historia kuponu z informacjami o kuponie i dwoma wpisami użycia'),
    },
  ],
  uwagi: [
    'Nie sprawdzaj karty przez płatność „Kupon" w kasie. Tamten przycisk nazywa się „Sprawdź i zapłać" i jeśli saldo karty pokrywa cały koszyk, sprzedaż zamyka się od razu — bez dodatkowego pytania. Do samego sprawdzenia służy tylko „Sprawdz kupon" nad koszykiem.',
    'Karta po terminie na liście „Kupony" wygląda jak aktywna (status „✅ Aktywny"). Decyduje kolumna „Ważność" — porównaj z dzisiejszą datą. Okno „Sprawdz kupon" w kasie powie to wprost: „Kupon wygasł".',
    'Lista w zakładce „Kupony" pokazuje tylko karty wystawione w Twoim sklepie (najnowsze 100). Jeśli klient kupił kartę w innym sklepie, na liście jej nie znajdziesz — sprawdź ją w kasie przez „Sprawdz kupon", to okno szuka we wszystkich sklepach.',
    'Kupon wykorzystany albo po terminie: nie da się nim zapłacić i kasjer tego nie zmieni — system nie ma przycisku „przedłuż" ani „przywróć saldo". Powiedz klientowi wprost, co pokazuje historia (data, kwota, paragon), a w sytuacji spornej odeślij do kierownika.',
    'Częściowo użyta karta zostaje „Aktywna" z mniejszą wartością. Status „Wykorzystany" pojawia się dopiero, gdy saldo spadnie do 0,00 zł.',
  ],
};

export default KUPON_SPRAWDZ;
